import type { ReactNode } from 'react';
import { MoreHorizontal } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './dropdown-menu';

export interface MenuItem { label: string; onSelect: () => void; icon?: ReactNode; danger?: boolean; disabled?: boolean }

/**
 * An overflow ("more actions") menu button, on shadcn's Dropdown Menu (Radix): arrow keys move between items, Escape
 * closes and returns focus, a click outside closes it. Renders nothing when there are no items, so a card never shows an
 * empty menu. Same props as the hand-made menu it replaced; the trigger keeps its `.overflow-trigger` look.
 */
export function OverflowMenu({ label, items }: { label: string; items: MenuItem[] }) {
  if (!items.length) return null;
  return <DropdownMenu modal={false}>
    <DropdownMenuTrigger className="overflow-trigger" aria-label={label}>
      <MoreHorizontal size={17} aria-hidden/>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" side="top" aria-label={label} className="min-w-[206px]">
      {items.map(item => <DropdownMenuItem key={item.label} disabled={item.disabled ?? false}
        variant={item.danger ? 'destructive' : 'default'} onSelect={() => item.onSelect()}>
        {item.icon}{item.label}
      </DropdownMenuItem>)}
    </DropdownMenuContent>
  </DropdownMenu>;
}
